import { ReactElement } from 'react';

interface Props {
  error: Error;
}
const ErrorScreen = ({ error }: Props): ReactElement => (
  <div
    className="flex w-screen h-screen justify-center flex-col items-center relative min-h-screen px-5 text-center"
    role="alert"
  >
    <img src="/lock-up.svg" width={200} alt="Stark Crawl Logo" />
    <h1 className="font-semibold text-2xl mt-8">{error.message}</h1>
  </div>
);

export default ErrorScreen;
